import AES from "crypto-js/aes";
import enc from "crypto-js/enc-utf8";

export function encrypt(text, key) {
  return AES.encrypt(text, key).toString();
}
export function decrypt(chiper = "", key) {
  return AES.decrypt(chiper.toString(), key).toString(enc);
}
